import { Directive, AfterViewInit, ElementRef } from '@angular/core';
import { TabsComponent } from '../widgets/tabs/index';

/*
 * This adds classes that make the tabs inside a modal look like left hand navigation.
 * This is done automatically through no effort of the developer.
 */
@Directive({
  selector: 'wlx-tabs',
  standalone: false,
})
export class WlTabsInModalDirective implements AfterViewInit {
  constructor(
    public _tabs: TabsComponent,
    public _element: ElementRef
  ) {}

  /**
   * triggered after all child view elements are created
   */
  ngAfterViewInit(): void {
    // Check if tabs component is initialized
    if (!this._tabs) return;

    const nativeElement = this._element.nativeElement;

    // Use native closest() to find ng2-bs3-modal elements (replaces jQuery .closest())
    const modalContent = nativeElement.closest('.modal-content');
    const modalDialog = nativeElement.closest('.modal-dialog');

    // Not found. These tabs are not in a window. Ignore.
    if (!modalContent) return;

    // In a window, but some dev requested to not enable this css via specific class
    if (modalDialog?.classList.contains('wl-disable-tabs-in-modal-css')) {
      return;
    }

    // Use setTimeout to avoid ExpressionChangedAfterItHasBeenCheckedError
    // when updating the child component property during the lifecycle hook
    setTimeout(() => (this._tabs.windowed = true));

    // Add a marker class to the modal content to allow CSS styling of the tab layout
    // inside the modal (e.g., removing margins/borders)
    if (!modalContent.classList.contains('wl-modal-has-wl-tab')) {
      modalContent.classList.add('wl-modal-has-wl-tab');
    }
  }
}
